import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// import { enableDebugTools } from '@angular/platform-browser';

// if (typeof window !== 'undefined') {
//   (window as any).ngHydrationDebug = true;
// }


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
